<section class="editor-panel">

  <!-- Tab bar -->
  <div class="editor-tab-bar" *ngIf="!embedded">
    <div [ngClass]="selectedTab === 'CONTENT' ? 'active-content-tab' : 'content-tab'"
         (click)="tabShift('CONTENT')">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
      </svg>
      Content
    </div>
    <div [ngClass]="selectedTab === 'STYLES' ? 'active-content-tab' : 'content-tab'"
         (click)="tabShift('STYLES')">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/>
        <circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/>
        <circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/>
        <circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/>
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>
      </svg>
      Styles
    </div>
  </div>

  <!-- ── CONTENT ──────────────────────────────────────────────── -->
  <div *ngIf="selectedTab === 'CONTENT' || embedded">

    <!-- Link Type -->
    <div class="editor-section" *ngIf="buttonData.hasOwnProperty('linkType')">
      <p class="prop-label" style="margin-bottom:10px;">Link Type</p>
      <div class="seg-buttons">
        <div *ngFor="let item of RedirectionLinkType; let i = index"
             (click)="buttonData.linkType = item.type"
             [ngClass]="{
               'seg-selected': buttonData.linkType === item.type,
               'seg-left':     i === 0,
               'seg-right':    i === RedirectionLinkType.length - 1
             }">
          {{item.type}}
        </div>
      </div>
    </div>

    <!-- Label -->
    <div class="editor-section" *ngIf="buttonData.hasOwnProperty('label')">
      <p class="prop-label" style="margin-bottom:8px;">Label</p>
      <input type="text" class="field-input w-100" [(ngModel)]="buttonData.label" placeholder="Button label">
    </div>

    <!-- URL / Email / Phone -->
    <div class="editor-section"
         *ngIf="buttonData.hasOwnProperty('linkType') && buttonData.linkType != RedirectionLink.Page && buttonData.linkType != RedirectionLink.section">
      <p class="prop-label" style="margin-bottom:8px;">
        <ng-container *ngIf="buttonData.linkType === RedirectionLink.External">Website URL</ng-container>
        <ng-container *ngIf="buttonData.linkType === RedirectionLink.Email">Email Address</ng-container>
        <ng-container *ngIf="buttonData.linkType === RedirectionLink.Phone">Phone Number</ng-container>
      </p>
      <input type="text" class="field-input w-100"
             [(ngModel)]="buttonData.redirectionUrl"
             [placeholder]="buttonData.linkType === RedirectionLink.External ? 'https://example.com' : ''">
    </div>

    <!-- Page select -->
    <div class="editor-section" *ngIf="buttonData.linkType === RedirectionLink.Page">
      <p class="prop-label" style="margin-bottom:8px;">Page</p>
      <mat-form-field appearance="outline" style="width:100%;">
        <mat-select [(ngModel)]="buttonData.pageId">
          <mat-option *ngFor="let page of templatePage" [value]="page.id"
            (click)="buttonData.redirectionUrl = page.path">{{page.pageName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Section select -->
    <div class="editor-section" *ngIf="buttonData.linkType === RedirectionLink.section">
      <p class="prop-label" style="margin-bottom:8px;">Section</p>
      <mat-form-field appearance="outline" style="width:100%;">
        <mat-select [(ngModel)]="buttonData.pageId">
          <mat-option *ngFor="let section of templatePage[currentPageIndex]?.components" [value]="section.id">
            {{section.sectionName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Open in new tab -->
    <div class="editor-section prop-row" *ngIf="buttonData.hasOwnProperty('newTab')">
      <span class="prop-label">Open in new browser tab</span>
      <input class="toggle-input" type="checkbox" [(ngModel)]="buttonData.newTab"
             role="switch" [class.active]="buttonData.newTab">
    </div>

  </div>

  <!-- ── STYLES ────────────────────────────────────────────────── -->
  <div *ngIf="selectedTab === 'STYLES' && !embedded">

    <!-- Preview -->
    <div class="editor-section">
      <p class="prop-label" style="margin-bottom: 10px;">Preview</p>
      <div class="preview-wrap">
        <button class="btn-preview"
          [style.borderRadius]="setBorderRadius()"
          [style.border]="setBorder()"
          [style.background]="setBackground()">
          <span *ngIf="buttonStyle?.type === 'Text'" [style.color]="buttonStyle?.background">
            {{ buttonData.label || 'Button Text' }}
          </span>
          <span *ngIf="buttonStyle?.type !== 'Text'" [style.color]="setColor()">
            {{ buttonData.label || 'Button Text' }}
          </span>
        </button>
      </div>
    </div>

    <!-- Variant -->
    <div class="editor-section">
      <div class="prop-row">
        <p class="prop-label mb-0">Button Variant</p>
        <div class="colorType-select">
          <select class="border-0 w-100" [(ngModel)]="buttonStyle.type" (ngModelChange)="changeButtonStyle()">
            <option *ngFor="let t of buttonTypes" [value]="t.type">{{t.type}}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Color Type -->
    <div class="editor-section" *ngIf="buttonStyle?.type === 'Solid'">
      <div class="prop-row">
        <p class="prop-label mb-0">Color Type</p>
        <div class="colorType-select">
          <select class="border-0 w-100" [(ngModel)]="buttonStyle.colorType" (ngModelChange)="changeButtonStyle()">
            <option *ngFor="let t of backgroundType" [value]="t">{{t}}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Solid color -->
    <ng-container *ngIf="buttonStyle?.colorType === 'Solid'">
      <div class="editor-section">
        <p class="prop-label" style="margin-bottom:8px;">{{ getColorLabel() }}</p>
        <div class="color-row">
          <div class="color-swatch-wrap" (click)="bgColorInput.click()">
            <input #bgColorInput type="color" class="hidden-color-input" [(ngModel)]="buttonStyle.background"
                   (ngModelChange)="getContrastTextColor(buttonStyle.background)">
            <div class="color-swatch-preview" [style.background]="buttonStyle.background"></div>
          </div>
          <input type="text" class="color-code-input" [(ngModel)]="buttonStyle.background"
                 (ngModelChange)="getContrastTextColor(buttonStyle.background)">
        </div>
      </div>
    </ng-container>

    <!-- Gradient colors -->
    <ng-container *ngIf="buttonStyle?.colorType === 'Gradient'">
      <div class="editor-section">
        <p class="prop-label" style="margin-bottom:8px;">Gradient Colors</p>
        <div class="gradient-row">
          <div class="gradient-swatch-wrap">
            <label class="swatch-label">Color 1</label>
            <div class="color-swatch-wrap" (click)="gradColor1.click()">
              <input #gradColor1 type="color" class="hidden-color-input" [(ngModel)]="buttonStyle.background"
                     (ngModelChange)="changeButtonStyle()">
              <div class="color-swatch-preview" [style.background]="buttonStyle.background"></div>
            </div>
          </div>
          <div class="gradient-swatch-wrap">
            <label class="swatch-label">Color 2</label>
            <div class="color-swatch-wrap" (click)="gradColor2.click()">
              <input #gradColor2 type="color" class="hidden-color-input" [(ngModel)]="buttonStyle.secondaryBackground"
                     (ngModelChange)="changeButtonStyle()">
              <div class="color-swatch-preview" [style.background]="buttonStyle.secondaryBackground"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Gradient Direction -->
      <div class="editor-section">
        <p class="prop-label" style="margin-bottom:8px;">Direction</p>
        <div class="direction-row">
          <div *ngFor="let d of directionType"
               class="direction-btn"
               [class.direction-active]="buttonStyle?.gradientDirection === d.type"
               (click)="buttonStyle.gradientDirection = d.type; changeButtonStyle()">
            <img [src]="buttonStyle?.gradientDirection === d.type ? d.activeIcon : d.icon"
                 width="16" height="16" alt="">
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Text Color -->
    <div class="editor-section" *ngIf="buttonStyle?.type !== 'Text'">
      <p class="prop-label" style="margin-bottom:8px;">Text Color</p>
      <div class="color-row">
        <div class="color-swatch-wrap" (click)="textColorInput.click()">
          <input #textColorInput type="color" class="hidden-color-input" [(ngModel)]="buttonStyle.textColor"
                 (ngModelChange)="changeButtonStyle()">
          <div class="color-swatch-preview" [style.background]="buttonStyle.textColor"></div>
        </div>
        <input type="text" class="color-code-input" [(ngModel)]="buttonStyle.textColor"
               (ngModelChange)="changeButtonStyle()">
      </div>
    </div>

    <!-- Corner Shape -->
    <div class="editor-section" *ngIf="buttonStyle?.type !== 'Text'">
      <div class="prop-row">
        <p class="prop-label mb-0">Corner Radius</p>
        <div class="shape-row">
          <div *ngFor="let s of buttonShapes"
               class="shape-btn"
               [class.shape-active]="buttonStyle?.shape === s.type"
               (click)="buttonStyle.shape = s.type; changeButtonStyle()">
            <img [src]="buttonStyle?.shape === s.type ? s.activeIcon : s.icon"
                 width="20" height="20" alt="">
          </div>
        </div>
      </div>
    </div>

  </div>

</section>
